import {
  Container,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import BannerAdminForm from "./BannerAdminForm";
import BlogAdminForm from "./BlogAdminForm";
import ProductAdminForm from "./ProductAdminForm";
import RecipeAdminForm from "./RecipeAdminForm";
import VideoAdminForm from "./VideoAdminForm";
import { useState } from "react";
import BannerList from "./BannerList";

export default function AdminDashboard() {
  const sections = ["Recipe", "Banner", "Blog", "Product", "Video"];
  const [selectedSection, setSelectedSection] = useState("Recipe");

  const renderForm = () => {
    switch (selectedSection) {
      case "Banner":
        return (
          <>
            <BannerAdminForm />
            <BannerList />
          </>
        );
      case "Blog":
        return <BlogAdminForm />;
      case "Product":
        return <ProductAdminForm />;
      case "Video":
        return <VideoAdminForm />;
      default:
        return <RecipeAdminForm />;
    }
  };

  return (
    <>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          fontWeight="bold"
          color="primary"
          sx={{ my: 4, textAlign: "center" }}
        >
          Admin Dashboard ✍️
        </Typography>
        <Grid container spacing={3}>
          {/* Sidebar Navigation */}
          <Grid item xs={12} md={3}>
            <List
              sx={{
                maxWidth: 250,
                bgcolor: "background.paper",
                borderRadius: 2,
                boxShadow: 3,
              }}
            >
              <Typography
                variant="h6"
                sx={{ p: 2, textAlign: "center", fontWeight: "bold" }}
              >
                Admin Forms
              </Typography>
              {sections.map((section) => (
                <ListItemButton
                  key={section}
                  selected={selectedSection === section}
                  onClick={() => setSelectedSection(section)}
                >
                  <ListItemText primary={section} />
                </ListItemButton>
              ))}
            </List>
          </Grid>
          {/* Dynamic Form Display */}
          <Grid item xs={12} md={9}>
            {renderForm()}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
